const BUFFER_SIZE = 4096;

const AudioContext = window.webkitAudioContext || window.AudioContext;
let context = AudioContext ? new AudioContext() : null;
let timeout;

function changeSampleRate() {
  if (/(iPhone|iPad)/i.test(navigator.userAgent)) {
    const buffer = context.createBuffer(1, 1, 44100);
    const dummy = context.createBufferSource();
    dummy.buffer = buffer;
    dummy.connect(context.destination);
    dummy.start(0);
    dummy.disconnect();

    timeout = setTimeout(() => {
      context.close(); // dispose old context
      context = new AudioContext();

      timeout = null;
    }, 5000);
  }
}

function bindSetting(ctx, splitter, merger, set, right = true) {
  const [
    frequency,
    gain,
  ] = set;
  const filter = ctx.createBiquadFilter();
  const gainNode = ctx.createGain();

  filter.type = 'bandpass';
  filter.frequency.value = frequency;

  gainNode.gain.value = 2 - gain;

  splitter.connect(filter, 1);
  filter.connect(gainNode);
  gainNode.connect(merger, 0, right ? 1 : 0);
}

export default function loadAudio(url, setting = {}, buffer) {
  if (!context) {
    return alert('此功能不支援您的瀏覽器');
  }
  if (timeout) clearTimeout(timeout);
  changeSampleRate();

  if (buffer) {
    if (!Array.isArray(setting.left) || !Array.isArray(setting.right)) {
      return false;
    }

    const source = context.createBufferSource();
    const audioBuffer = context.createBuffer(2, buffer.length * BUFFER_SIZE * 2, context.sampleRate);
    const channel = audioBuffer.getChannelData(0);
    const channel2 = audioBuffer.getChannelData(1);
    for (let i = 0; i < buffer.length; i++) {
      for (let j = 0; j < BUFFER_SIZE; j++) {
        channel[i * BUFFER_SIZE + j] = buffer[i][j];
        channel2[i * BUFFER_SIZE + j] = buffer[i][j];
      }
    }
    source.buffer = audioBuffer;
    source.loop = true;
    source.loopEnd = 6;
    // Play Audio
    const splitter = context.createChannelSplitter(2);
    const merger = context.createChannelMerger(2);

    source.connect(splitter);

    setting.left.forEach(set => bindSetting(context, splitter, merger, set, false));
    setting.right.forEach(set => bindSetting(context, splitter, merger, set, true));

    merger.connect(context.destination);

    return source;
  }

  // Audio from url
  return new Promise((resolve, reject) => {
    if (!Array.isArray(setting.left) || !Array.isArray(setting.right)) {
      return reject(new Error('setting left and right should be array'));
    }

    return fetch(url)
      .then(response => response.arrayBuffer())
      .then(response => context.decodeAudioData(response, audioBuffer => {
        // Play Audio
        const source = context.createBufferSource();
        source.buffer = audioBuffer;
        source.loop = true;

        const splitter = context.createChannelSplitter(2);
        const merger = context.createChannelMerger(2);

        source.connect(splitter);

        setting.left.forEach(set => bindSetting(context, splitter, merger, set, false));
        setting.right.forEach(set => bindSetting(context, splitter, merger, set, true));

        merger.connect(context.destination);

        resolve(source);
      }, e => reject(e))
    )
    .catch((ex) => reject(ex));
  });
}



// WEBPACK FOOTER //
// ./libs/equalizer.js